import React, { useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestion } from '@fortawesome/free-solid-svg-icons';
import clicksound from '../components/music/click.mp3';

const ButtonTanya = ({ onClick }) => {
    const audioRef = useRef(null);

    const handleClick = (e) => {
        if (audioRef.current) {
            audioRef.current.play();
        }
        if (onClick) {
            onClick(e);
        }
    };

    return (
        <button className="tanya-button lg:w-14 lg:h-14 sm:w-10 sm:h-10" onClick={handleClick}>
            <FontAwesomeIcon icon={faQuestion} className='sm:text-xl lg:text-2xl font-extrabold'/>
            <audio ref={audioRef} src={clicksound} />
        </button>
    );
};

export default ButtonTanya;
